export default "__VITE_ASSET__BfV0cyWy__"